import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { AppComponentGenericComponent } from '../../custom/app-component-generic/app-component-generic.component';
import { DataService } from '../../../services/data.service';
import { OrderByPipe } from '../../../pipes/order-by.pipe';

@Component({
  selector: 'app-messi-notificatori',
  templateUrl: './messi-notificatori.component.html',
  styleUrls: ['./messi-notificatori.component.css']
})
export class MessiNotificatoriComponent extends AppComponentGenericComponent implements OnInit {
	messiNotificatoriSync: Subscription;
	messiNotificatori: any[];

	nuovoMesso: any = {
		nome : '',
		cognome : '',
		comune_id : ''
	}

	messoModificato: any = {
		id : '',
		nome : '',
		cognome : '',
		comune_id : ''
	}

	constructor(protected dataService: DataService){
		super(dataService, 'messi-notificatori');
		this.messiNotificatori = [];
	}

	ngOnInit() {
		this.messiNotificatoriSync = this.dataService.messiNotificatori$.subscribe(
			messiNotificatori => {
				if (messiNotificatori) {
					this.messiNotificatori = messiNotificatori;
				}
				else {
					this.messiNotificatori = [];
				}
			});
	}

	reset(){
		this.nuovoMesso.nome = '';
		this.nuovoMesso.cognome = '';
		this.nuovoMesso.comune_id = '';
		this.messoModificato.id = '';
		this.messoModificato.nome = '';
		this.messoModificato.cognome = '';
		this.messoModificato.comune_id = '';
	}

	aggiungiMessoNotificatore() {
		this.dataService.insert("messi_notificatori", this.nuovoMesso, true, (error, newId) => {
			if (error) {
				this.dataService.openMessage('INSERIMENTO MESSO NOTIFICATORE','si è verificato un errore');
			}
			else {
				this.reset();
			}
		});
	}

	apriModificaMesso(messo: any) {
		this.messoModificato.id = messo.id;
		this.messoModificato.nome = messo.nome;
		this.messoModificato.cognome = messo.cognome;
		this.messoModificato.comune_id = messo.comuneId;
	}

	salvaModificaMesso() {
		let localFilters = [];
		localFilters.push({ type: "=", key: "id", value: this.messoModificato.id });

		this.dataService.update("messi_notificatori", localFilters, this.messoModificato, true, (error,res) => {
			if(res){
				this.reset();
			}
		});
	}

	annullaModificaMesso() {
		this.reset();
	}

	eliminaMesso(messo: any) {
		let localFilters = [];
		localFilters.push({ type: "=", key: "id", value: messo.id });

		this.dataService.delete("messi_notificatori", localFilters, true, (error,res) => {
			if (error) {
				//this.dataService.openMessage('ELIMINAZIONE MESSO NOTIFICATORE','si è verificato un errore');
			}
			if(res){
				this.reset();
			}
		});
	}
}
